/**
 * @generated SignedSource<<5a3bc6510292ce94117d6582f5f11dc6>>
 * @relayHash a9f32b8a40e62d50ea93109e8a20f2cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fb739b5da2438ed07259ec682dabb897bf77f788cc0ef58a85897005e02467e5

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraIssueNavigatorSearchLayout = "DETAIL" | "LIST" | "%future added value";
export type useSelectedViewMutationOldMutation$variables = {
  cloudId: string;
  searchLayout?: JiraIssueNavigatorSearchLayout | null | undefined;
};
export type useSelectedViewMutationOldMutation$data = {
  readonly jira: {
    readonly userPreferences: {
      readonly setIssueNavigatorSearchLayout: {
        readonly errors: ReadonlyArray<{
          readonly message: string | null | undefined;
        }> | null | undefined;
        readonly issueNavigatorSearchLayout: JiraIssueNavigatorSearchLayout | null | undefined;
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useSelectedViewMutationOldMutation = {
  response: useSelectedViewMutationOldMutation$data;
  variables: useSelectedViewMutationOldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchLayout"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraUserPreferencesMutation",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "searchLayout",
                "variableName": "searchLayout"
              }
            ],
            "concreteType": "JiraIssueNavigatorSearchLayoutMutationPayload",
            "kind": "LinkedField",
            "name": "setIssueNavigatorSearchLayout",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "success"
              },
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "issueNavigatorSearchLayout"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSelectedViewMutationOldMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSelectedViewMutationOldMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "fb739b5da2438ed07259ec682dabb897bf77f788cc0ef58a85897005e02467e5",
    "metadata": {},
    "name": "useSelectedViewMutationOldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "fc5879cd5e3ff3110514f54a88b6d958";

export default node;
